export const importFromCsv = {
  title: '洗剤のCSVインポート',
  importSuccessfully: '洗剤のインポートに成功しました！',
  importFailed: '洗剤のインポートに失敗しました！',
}
